import { BehaviorSubject } from 'rxjs';
export const getCreateUserFormStore = () => {
    const getInitialState = () => ({
        clientCompaniesRoles: [],
        isLoadingClientCompaniesRoles: false
    });
    const createUserFormSubject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => createUserFormSubject.subscribe(callback);
    const setIsLoadingClientCompaniesRoles = (isLoadingClientCompaniesRoles) => {
        createUserFormSubject.next({
            ...createUserFormSubject.getValue(),
            isLoadingClientCompaniesRoles: isLoadingClientCompaniesRoles
        });
    };
    const clientCompaniesRolesFetchSuccess = (clientCompaniesRoles) => {
        createUserFormSubject.next({
            ...createUserFormSubject.getValue(),
            clientCompaniesRoles: clientCompaniesRoles,
            isLoadingClientCompaniesRoles: false
        });
    };
    const reset = () => {
        createUserFormSubject.next(getInitialState());
    };
    const getClientCompaniesRoles = () => createUserFormSubject.getValue().clientCompaniesRoles;
    return {
        getInitialState,
        subscribe,
        setIsLoadingClientCompaniesRoles,
        clientCompaniesRolesFetchSuccess,
        reset,
        getClientCompaniesRoles
    };
};
